import React, { useEffect, useState } from "react";
import { Plus, Trash2, ArrowRight } from "lucide-react";
import { api } from "../../api";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { useToast } from "../../hooks/use-toast";

export default function Redirects() {
  const { toast } = useToast();
  const [items, setItems] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const load = async () => { const { data } = await api.get("/redirects"); setItems(data); };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!from || !to) { toast({ title: "From and To required" }); return; }
    try {
      await api.post("/admin/redirects", { from, to });
      setFrom(""); setTo("");
      load();
      toast({ title: "Redirect added" });
    } catch { toast({ title: "Failed" }); }
  };
  const remove = async (id) => { await api.delete(`/admin/redirects/${id}`); load(); };

  return (
    <div>
      <h1 className="text-2xl md:text-3xl font-bold">Redirects (301)</h1>
      <p className="text-slate-400 text-sm mt-1">Send old URLs to new ones. Useful for migrating from <code className="text-amber-300">daddyanna.com</code> URL structures.</p>

      <div className="mt-6 card-dark p-5">
        <div className="grid sm:grid-cols-[1fr_1fr_auto] gap-3">
          <Input value={from} onChange={(e) => setFrom(e.target.value)} placeholder="/old-path" className="bg-[#0c1530] border-white/10 text-white" />
          <Input value={to} onChange={(e) => setTo(e.target.value)} placeholder="/new-path" className="bg-[#0c1530] border-white/10 text-white" />
          <Button onClick={add} className="btn-gold border-0"><Plus className="w-4 h-4 mr-1" /> Add</Button>
        </div>
      </div>

      <div className="mt-5 card-dark overflow-hidden">
        {items.length === 0 ? (
          <div className="p-10 text-center text-slate-400">No redirects yet</div>
        ) : (
          <ul className="divide-y divide-white/5">
            {items.map((r) => (
              <li key={r.id} className="p-4 flex items-center gap-4">
                <code className="text-rose-300 font-mono text-sm">{r.from}</code>
                <ArrowRight className="w-4 h-4 text-slate-500" />
                <code className="text-emerald-300 font-mono text-sm">{r.to}</code>
                <div className="flex-1" />
                <button onClick={() => remove(r.id)} className="text-rose-300 p-1.5 rounded hover:bg-rose-500/10"><Trash2 className="w-4 h-4" /></button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
